import { makeAutoObservable } from "mobx";
import { REPORT_DATE_TYPES } from "../assets/constants";

const formatLocalDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const getDateRange = (type) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  switch (type) {
    case REPORT_DATE_TYPES.TODAY: {
      return {
        startDate: formatLocalDate(today),
        endDate: formatLocalDate(today),
      };
    }
    case REPORT_DATE_TYPES.YESTERDAY: {
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      return {
        startDate: formatLocalDate(yesterday),
        endDate: formatLocalDate(yesterday),
      };
    }
    case REPORT_DATE_TYPES.LAST_7_DAYS: {
      const lastWeek = new Date(today);
      lastWeek.setDate(lastWeek.getDate() - 7);
      return {
        startDate: formatLocalDate(lastWeek),
        endDate: formatLocalDate(today),
      };
    }
    case REPORT_DATE_TYPES.LAST_30_DAYS: {
      const lastMonth = new Date(today);
      lastMonth.setDate(lastMonth.getDate() - 30);
      return {
        startDate: formatLocalDate(lastMonth),
        endDate: formatLocalDate(today),
      };
    }
    default:
      return {
        startDate: formatLocalDate(today),
        endDate: formatLocalDate(today),
      };
  }
};

class DateStore {
  // Get first day of current month
  firstDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  today = new Date();

  dateType = REPORT_DATE_TYPES.CUSTOM;
  startDate = formatLocalDate(this.firstDayOfMonth);
  endDate = formatLocalDate(this.today);

  constructor() {
    makeAutoObservable(this);
  }

  setDateType(type) {
    const { startDate, endDate } = getDateRange(type);
    this.dateType = type;
    this.startDate = startDate;
    this.endDate = endDate;
  }

  setCustomDateRange(startDate, endDate) {
    this.dateType = REPORT_DATE_TYPES.CUSTOM;
    this.startDate = startDate;
    this.endDate = endDate;
  }

  getFormattedDates() {
    return {
      startDate: this.startDate,
      endDate: this.endDate,
      dateType: this.dateType,
    };
  }
}

const dateStore = new DateStore();

export default dateStore;
